export default "__VITE_ASSET__DkTvbliG__"